module.exports = __webpack_public_path__ + "img/60f10.4d125369.jpg";